import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';

@Component({
	selector: 'kpa-sso-callback',
	templateUrl: './sso-callback.component.html',
	styleUrl: './sso-callback.component.scss',
})
export class SsoCallbackComponent implements OnInit {
	isLoading = true;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private authService: AuthService
	) {}

	ngOnInit(): void {
		const code = this.route.snapshot.queryParamMap.get('code');
		const error = this.route.snapshot.queryParamMap.get('error');

		if (error || !code) {
			this.handleFailure();
			return;
		}

		this.authService.ssoExchange(code).subscribe({
			next: (response) => {
				this.isLoading = false;
				if (response && response.accessToken) {
					this.router.navigate(['/']);
				} else {
					this.handleFailure();
				}
			},
			error: () => {
				this.handleFailure();
			},
		});
	}

	// Redirect to the sign-in page with an ssoError flag so it renders the standard inline error
	// banner (consistent with password-login failures) instead of a transient bottom toast.
	private handleFailure(): void {
		this.isLoading = false;
		this.router.navigate(['/signin'], { queryParams: { ssoError: '1' } });
	}
}
